import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
// Action Types
import { actionTypes } from '../action-types';
export var openOverlay = function openOverlay(overlayId) {
  return function (dispatch) {
    return Promise.resolve(dispatch({
      payload: {
        overlayId: overlayId
      },
      type: actionTypes.OVERLAY_OPEN
    }));
  };
};
export var closeOverlay = function closeOverlay(overlayId) {
  return function (dispatch) {
    return Promise.resolve(dispatch({
      payload: {
        overlayId: overlayId
      },
      type: actionTypes.OVERLAY_CLOSE
    }));
  };
};
export var closeAllOverlays = function closeAllOverlays() {
  return function (dispatch) {
    return Promise.resolve(dispatch({
      type: actionTypes.OVERLAY_CLOSE_ALL
    }));
  };
};